/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ng2-translate/src/translate.pipe';
import * as import2 from 'ng2-translate/src/translate.service';
import * as import3 from '@angular/common';
import * as import4 from './field-group.component';
import * as import5 from '@angular/forms';
const styles_FieldGroupComponent:any[] = ([] as any[]);
export const RenderType_FieldGroupComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_FieldGroupComponent,
  data: {}
}
);
function View_FieldGroupComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'field-group-title'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.onActivateTitle.emit()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n    ',
      '\n'
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform(co.title,co.translationParams));
    ck(v,1,0,currVal_0);
  });
}
export function View_FieldGroupComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_FieldGroupComponent_1)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'field-group-body'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    import0.ɵncd((null as any),0),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import4.FieldGroupComponent = v.component;
    const currVal_0:any = co.title;
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_FieldGroupComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-field-group',([] as any[]),(null as any),(null as any),(null as any),View_FieldGroupComponent_0,RenderType_FieldGroupComponent)),
    import0.ɵdid(49152,(null as any),0,import4.FieldGroupComponent,([] as any[]),(null as any),(null as any)),
    import0.ɵprd(5120,(null as any),import5.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import4.FieldGroupComponent])
  ]
  ,(null as any),(null as any));
}
export const FieldGroupComponentNgFactory:import0.ComponentFactory<import4.FieldGroupComponent> = import0.ɵccf('woa-field-group',import4.FieldGroupComponent,View_FieldGroupComponent_Host_0,{
  title: 'title',
  translationParams: 'translationParams'
}
,{onActivateTitle: 'onActivateTitle'},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvaW5wdXRzL2Zvcm0vZmllbGQtZ3JvdXAvZmllbGQtZ3JvdXAuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvaW5wdXRzL2Zvcm0vZmllbGQtZ3JvdXAvZmllbGQtZ3JvdXAuY29tcG9uZW50LnRzIiwibmc6Ly8vaG9tZS9ydW5uZXIvd29yay93ZWItb3JkZXJpbmctYXBwL3dlYi1vcmRlcmluZy1hcHAvc3JjL2FwcC9pbnB1dHMvZm9ybS9maWVsZC1ncm91cC9maWVsZC1ncm91cC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvaW5wdXRzL2Zvcm0vZmllbGQtZ3JvdXAvZmllbGQtZ3JvdXAuY29tcG9uZW50LnRzLkZpZWxkR3JvdXBDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2ICpuZ0lmPVwidGl0bGVcIiBjbGFzcz1cImZpZWxkLWdyb3VwLXRpdGxlXCIgKGNsaWNrKT1cIm9uQWN0aXZhdGVUaXRsZS5lbWl0KClcIj5cbiAgICB7e3RpdGxlIHwgdHJhbnNsYXRlOiB0cmFuc2xhdGlvblBhcmFtc319XG48L2Rpdj5cbjxkaXYgY2xhc3M9XCJmaWVsZC1ncm91cC1ib2R5XCI+XG4gICAgPG5nLWNvbnRlbnQ+PC9uZy1jb250ZW50PlxuPC9kaXY+XG4iLCI8d29hLWZpZWxkLWdyb3VwPjwvd29hLWZpZWxkLWdyb3VwPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O01DQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7TUFBQTtNQUE2QztRQUFBO1FBQUE7TUFBQTtNQUE3QztJQUFBO0lBQThFO01BQUE7TUFBQTtJQUFBO0lBQUE7Z0JBQUE7OztJQUFBO0lBQUE7Ozs7SUFBQTtJQUFBOzs7OztJQUE5RTtnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBRU07TUFDTjtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQThCO2dCQUMxQjtJQUF5QjtJQUN2Qjs7OztJQUxEO0lBQUwsU0FBSyxTQUFMOzs7OztJQ0FBO2dCQUFBO2dCQUFBO01BQUE7SUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/app/inputs/form/field-group/field-group.component.ngfactory.ts